module.exports = __webpack_public_path__ + "img/terracenew_box25.de42a0f3.jpg";